import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { Button } from '@tink/core/src/components/atoms/Button/Button';
import { styled } from '../../../../../core/theme/styled';

export const StyledButton = styled(Button)`
  && {
    padding: 0;
    min-width: unset;
  }
`;

export const StyledBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledChipTanBox = styled(StyledBox)`
  width: 100%;
  height: auto;
  flex-direction: column;
`;
